import React from 'react';

const VerticalStepper = ({ steps }) => { 

  return (
    <div style={{ width: '100%', maxWidth: 360 }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
        {steps && Array.isArray(steps) && steps.map((step, index) => {
          return (
            <div key={index} style={{ position: 'relative', display: 'flex', alignItems: 'center', marginBottom: 18 }}>
              <div style={{ width: 14, height: 14, zIndex: 10, top: 4, borderRadius: '50%', backgroundColor: step.status == 1 ? 'green' : 'gray', marginRight: 10, flexShrink: 0 }}></div>
              <div style={{ flexGrow: 1 }} className='fs-13 ff-poppins-regular m-0'>
                <span style={{ marginBottom: 4 }}>{step.lable}</span><br></br>

                {step.date && (
                  <span style={{ fontSize: 12, color: 'gray' }}>
                    {`${new Date(step.date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })} at ${new Date(step.date).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true })}`}
                  </span>

                )}

              </div>
              {index != steps.length - 1 &&


                <>
                  <div style={{ position: 'absolute', left: 6, top: 17, width: 2, height: 49, backgroundColor: step.status == 1 ? 'green' : 'gray' }}></div>
                  <div style={{ position: 'absolute', left: 6, top: 50, width: 2, height: 48, backgroundColor: step.status == 1 ? 'green' : 'gray' }}></div>
                </>
              }
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VerticalStepper;
